import { render } from "./InternalTransferPartialFailure.vue?vue&type=template&id=5ea1cba4&scoped=true"
import script from "./InternalTransferPartialFailure.vue?vue&type=script&lang=js"
export * from "./InternalTransferPartialFailure.vue?vue&type=script&lang=js"

import "./InternalTransferPartialFailure.vue?vue&type=style&index=0&id=5ea1cba4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ea1cba4"]])

export default __exports__